// extracted by mini-css-extract-plugin
module.exports = {"root":"input_root__48W-H","label":"input_label__1oWf_","label__span":"input_label__span__1GhCq","input":"input_input__2IsVw","message":"input_message__1TOql"};